const SpotifyIcon = () => (
  <svg
    viewBox="0 0 168 168"
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 hover:scale-110"
  >
    <path
      d="M84,0 C37.5,0 0,37.5 0,84 C0,130.5 37.5,168 84,168 C130.5,168 168,130.5 168,84 C168,37.5 130.5,0 84,0 ZM121.5,121.2 C120.3,123.6 117,124.5 114.6,123.3 C94.5,112.2 67.5,110.4 42.9,117.9 C40.2,118.8 37.5,117.3 36.6,114.6 C35.7,111.9 37.2,109.2 39.9,108.3 C66.9,100.2 95.7,102.3 118.5,114.6 C121.2,115.8 122.4,119.1 121.5,121.2 ZM131.1,99.6 C129.3,102.6 125.7,103.5 122.7,101.7 C100.2,89.1 67.8,87.3 44.1,95.4 C41.1,96.3 37.8,94.8 36.9,91.8 C36,88.8 37.5,85.5 40.5,84.6 C66.3,75.9 101.1,77.4 126.9,91.2 C129.9,92.7 131.4,96.6 131.1,99.6 ZM131.1,78.6 C110.1,65.4 57.9,62.4 36.9,70.5 C34.2,71.4 31.2,70.2 30.3,67.5 C29.4,64.8 30.6,61.8 33.3,60.9 C56.1,52.2 111,55.5 135.3,70.8 C138,72.3 138.9,75.9 137.4,78.6 C135.9,81.3 132.3,82.2 129.6,80.7 Z"
      fill="#1DB954"
    />
  </svg>
);

export default SpotifyIcon;